import React from "react";

const HeadlineCards = () => {
  return (
    <div className="max-w-[1640px] mx-auto p-4 py-12 grid md:grid-cols-3 gap-6">
      {/* Cards */}
      <div className="rounded-xl relative ">
        {/* Overlay */}
        <div className="absolute w-full h-full bg-black/50 rounded-xl text-white">
          <p className="font-bold text-2xl px-2 pt-4 ">Breakfast</p>
          <p className="px-2">serves Idli, Vada, Poori, Rice Bath</p>
          <button className="border-white bg-white text-black mx-2 absolute bottom-4">
            Order Now!
          </button>
        </div>
        <img
          className="max-h-[160] md:max-h-[200px] w-full object-cover rounded-xl "
          src="paddu.png"
          alt="/"
        />
      </div>
      <div className="rounded-xl relative ">
        {/* Overlay */}
        <div className="absolute w-full h-full bg-black/50 rounded-xl text-white">
          <p className="font-bold text-2xl px-2 pt-4 ">Lunch</p>
          <p className="px-2">serves South Indian meals and Rice Sambar</p>
          <button className="border-white bg-white text-black mx-2 absolute bottom-4">
            Order Now!
          </button>
        </div>
        <img
          className="max-h-[160] md:max-h-[200px] w-full object-cover rounded-xl "
          src="south-meal.png"
          alt="/"
        />
      </div>
      <div className="rounded-xl relative ">
        {/* Overlay */}
        <div className="absolute w-full h-full bg-black/50 rounded-xl text-white">
          <p className="font-bold text-2xl px-2 pt-4 ">Non Veg</p>
          <p className="px-2">
            Serves Chicken Biryani, Fish Curry, Fish Roast and Chicken Curry
          </p>
          <button className="border-white bg-white text-black mx-2 absolute bottom-4">
            Order Now!
          </button>
        </div>
        <img
          className="max-h-[160] md:max-h-[200px] w-full object-cover rounded-xl "
          src="biryani1.png"
          alt="/"
        />
      </div>
    </div>
  );
};

export default HeadlineCards;
